<template>
  <div class="ml-3 mb-3 current-olympiad-div mt-3" :style="{borderColor: activeColorOlymp}"
       v-if="olympiad && olympiad.yearEnd >= (new Date()).getFullYear()">
    <div class="current-olympiad-div-header pt-2" :style="{backgroundColor: activeColorOlymp}">
      <p class="mb-0">Текущая олимпиада</p>
    </div>
    <div class="p-2 text-center">
      <div>
        <em><strong><a href="https://olympiad.gazprom.ru/" target="_blank">{{olympiad.title}}</a></strong></em>
      </div>
      <div v-if="!isMember">
        <b-button class="mt-1" variant="warning" style="width: 100%"
                  @click="registerToOlymp">Принять участие</b-button>
      </div>
      <div v-if="isMember">
        Вы зарегистрированы!
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OlympiadRegisterBlock',
  data() {
    return {
      isMember: false,
      isReadyComponent: false,
      activeColorOlymp: '#f79520'
    }
  },
  mounted() {
    this.fetchCurrentOlympiad().then(() => {
      if (_.get(this.olympiad, 'currentUser.participates')) {
        this.isMember = true
        this.activeColorOlymp = '#5cb85c'
      }
    })
  },
  methods: {
    ...mapActions({
      fetchCurrentOlympiad: 'olympiads/fetchCurrentOlympiad',
      registerInOlympiad: 'olympiads/registerInOlympiad',
      pushToasts: 'toasts/pushToasts',
      fetchUnreadNots: 'notifications/fetchUnreadNots',
      fetchLatestNots: 'notifications/fetchLatestNots'
    }),
    registerToOlymp() {
      const url = document.location.href.includes('dev')
        ? 'https://dev.gazprom.etu.ru/login'
        : 'https://olympiad.gazprom.ru/login'
      window.open(url, '_blank')
    }
  },
  computed: {
    ...mapGetters({
      olympiad: 'olympiads/getCurrentOlympiad',
      currUser: 'currentUser/getCurrentUser'
    })
  }
}
</script>

<style scoped>
  .current-olympiad-div {
    width: 230px;
    border: 1px solid;
    font-family: "Roboto", sans-serif;
    font-size: 15px;
  }
  .current-olympiad-div-header {
    text-align: center;
    color: white;
    height: 40px;
  }
</style>
